import App from './components/App.svelte';

if ('serviceWorker' in navigator) {
	navigator.serviceWorker
		.register('sw.js')
		.then(function () {
			console.log("Service Worker Registered");
		});
}

var app = new App({
	target: document.body,
});

export default app;